import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import mpx from '../../../actions/mpx_data';
import h, { getCountry } from '../../../helpers/common';
import url from '../../../helpers/url';
import useToggleDetailOverlay from '../../../hooks/useToggleDetailOverlay';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
import { __ } from '../../../translations';
import { getPathNameWithoutLangPrefix } from '@intigral/utils';
import { useLoadItemDataById } from '../hooks/useLoadItemDataById';

export const useOverlayAactions = () => {
    // state
    const [selectedMovieId, setSelectedMovieId] = useState(null);
    const [currentItemGuid, setCurrentItemGuid] = useState(null);
    const [isSeries, setIsSeries] = useState(false);
    const [seasons, setSeasons] = useState([]);
    const [episodes, setEpisodes] = useState([]);

    // redux state
    const movieOverlay = useSelector((state: any) => state.movieOverlay);
    const searchString = new URLSearchParams(window.location.search);

    // hooks
    const location = useLocation();
    const { closeDetailOverlay } = useToggleDetailOverlay();
    const { promotionProviderImages } = useConfigurationSections();

    const closeOverlay = () => {
        setSelectedMovieId(null);
        closeDetailOverlay();
    };

    // react querry hooks
    const {
        isLoading: isVodLoading,
        isError: isVodError,
        data: vodData,
    } = useLoadItemDataById(selectedMovieId, currentItemGuid, isSeries);

    const { data, isError } = useQuery({
        queryKey: ['overlay', selectedMovieId],
        enabled: vodData !== null && vodData !== undefined,
        queryFn: async () => {
            const seriesSeasons = await mpx.getSeasons(vodData.Id, `{PC}{${getCountry()}}`);
            if (seriesSeasons.length > 0) {
                const getEpisodes = await mpx.getEpisodes(seriesSeasons[0].Id);
                getEpisodes
                    .map((episode) => episode.runtime) // Extract durations
                    .reduce((acc, duration) => acc + duration, 0); // Sum durations

                return { seriesSeasons, episodesList: getEpisodes };
            }
            return { seriesSeasons, episodesList: [] };
        },
        refetchOnWindowFocus: false,
    });

    // useEffects
    useEffect(() => {
        if (getPathNameWithoutLangPrefix(location.pathname) !== 'play') {
            setCurrentItemGuid(url.getQuery('guid'));
            setIsSeries(url.getQuery('series') !== null);
            setSelectedMovieId(url.getQuery('movie') || url.getQuery('series'));
        } else {
            closeOverlay();
        }
    }, [movieOverlay?.isVisible, searchString?.toString()]);

    useEffect(() => {
        setEpisodes(data?.episodesList ?? []);
    }, [data?.episodesList]);

    useEffect(() => {
        setSeasons(data?.seriesSeasons ?? []);
    }, [data?.seriesSeasons]);

    return {
        isVodLoading,
        isError,
        isVodError,
        selectedMovieId,
        vodData,
        seasons,
        episodes,
        promotionProviderImages,
        closeOverlay,
    };
};
